import React, {useState} from 'react';
import './Buttons.scss';
import {Modal} from "rsuite";

const Buttons = (props) => {
    const {buttons} = props;
    const {handleButtonClick} = props;
    const {buttonContainerClass} = props;
    const {buttonContainerStyles} = props;

    return (<>
            <div className={`dynamic-buttons d-flex  ${buttonContainerClass}`} style={buttonContainerStyles}>
                {buttons && buttons.map(button =>
                    (<button
                        className={`d-flex flex-row justify-content-center ${button.class}`}
                        id={button?.id}
                        onClick={(e) => handleButtonClick(button.target, button.content)}
                        style={button?.style}>
                        {button?.icon?.position == 'start' &&
                            <img src={button?.icon.image} width={button?.icon?.size}/>
                        }
                        {button?.text && button?.text}
                        {button?.icon?.position == 'end' &&
                            <img src={button?.icon.image} width={button?.icon?.size}/>
                        }
                    </button>)
                )}
            </div>
        </>
    );
}

export default Buttons;